import {
  FETCH_USER_DATA,
  HEADER_STATUS,
  MINI_MENU,
  INQUERY,
  INSUREDEQUALPOLICYHOLDER,
  UNITLINKDATA,
  UNIUVERSALDATA
} from "../type";

export function userData(details:any) {
  return {
    type: FETCH_USER_DATA,
    payload: details,
  };
}

export function menuStatus(isOpen:boolean) {
  return {
    type: HEADER_STATUS,
    payload: isOpen,
  };
}
export function miniMenuStatus(isOpen:boolean) {
  return {
    type: MINI_MENU,
    payload: isOpen,
  };
}

export function inqueryDataa(details:any) {
  return {
    type: INQUERY,
    payload: details,
  };
}

export function universalDataa(details:any) {
  return {
    type: UNIUVERSALDATA,
    payload: details,
  };
}
export function unitLinkDataa(details:any) {
  return {
    type: UNITLINKDATA,
    payload: details,
  };
}
export function isEqual(isEqual:any) {

  return {
    type: INSUREDEQUALPOLICYHOLDER,
    payload: isEqual,
  };
}







